import script from "./InitialAuxiliary.vue?vue&type=script&setup=true&lang=js"
export * from "./InitialAuxiliary.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__